import { render, staticRenderFns } from "./ExtMapMappingConfigCompoment.vue?vue&type=template&id=854d86c2"
import script from "./ExtMapMappingConfigCompoment.vue?vue&type=script&lang=js"
export * from "./ExtMapMappingConfigCompoment.vue?vue&type=script&lang=js"
import style0 from "./ExtMapMappingConfigCompoment.vue?vue&type=style&index=0&id=854d86c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports